import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Services
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  // Objetos Observable y Emiters
  private showMenuMobile$ = new Subject<boolean>();

  private showShoppingCar$ = new Subject<boolean>();

  private itemMenuSelected$ = new Subject<number>();

  private urlLogo$ = new Subject<string>();

  private updateNumberOrdersAndShoppingCar$ = new Subject<boolean>();

  constructor(
    private _httpService: HttpService
  ) { }

  // Mostrar u ocultar carrito de compras
  emmiterShowShoppingCar(val: boolean): void {
    this.showShoppingCar$.next(val);
  }

  getSubjetShowShoppingCar(): Subject<boolean> {
    return this.showShoppingCar$;
  }
  
  // Mostrar u ocultar menu para moviles
  emmiterShowMenuMobile(val: boolean): void {
    this.showMenuMobile$.next(val);
  }
  

  getSubjetShowMenuMobile(): Subject<boolean> {
    return this.showMenuMobile$;
  }
  
  // Seleccionar item del menu
  emmiterSelectItemMenu(val: number): void {
    this.itemMenuSelected$.next(val);
  }

  getSubjetItemMenuSelected(): Subject<number> {
    return this.itemMenuSelected$;
  }

  // Cambiar logo del Header
  emmiterChangeUrlLogo(val: string): void {
    this.urlLogo$.next(val);
  }

  getSubjetUrlLogo(): Subject<string> {
    return this.urlLogo$;
  }

  // Actualizar la cantidad de ordenens y carrito de compra
  emmiterUpdateNumberOrdersAndShoppingCar(val: boolean): void {
    this.updateNumberOrdersAndShoppingCar$.next(val);
  }

  getSubjetUpdateNumberOrdersAndShoppingCar(): Subject<boolean> {
    return this.updateNumberOrdersAndShoppingCar$;
  }


  getListProducts() {
    let clientId = localStorage.getItem('clientId');
    let headers = {
      'dataItems': 'true',
      // 'dataCompra': 'true',
      'modality': localStorage.getItem('modality'),
      'clientId': clientId
    }
    return this._httpService.httpGet(`compras/compra/actual`, headers);
  }
  
  deleteProduct(productId: number) {
    return this._httpService.httpDelete(`compras/item/${productId}`);
  }

  deleteOrder() {
    let clientId = localStorage.getItem('clientId');
    let headers = {
      'clientId': clientId
    }
    return this._httpService.httpDelete(`compras/compra/actual`, headers);
  }

  getDataOrderAndShoppingCar(){
    let userId = localStorage.getItem('uid');
    let headers = {
      'dataOrdenes': 'true',
      'dataUsuario': 'true'
    };
    return this._httpService.httpGet(`usuarios/usuario/${userId}`, headers);
  }

  getCompanyLogo() {
    let companyId: string = localStorage.getItem('companyId');
    let headers: any = {
      'dataEmpresaOnly': 'true'
    };
    return this._httpService.httpGet(`clientes?company_id=${companyId}`, headers);
  }
  
}
